export default defineNuxtPlugin(() => {
    const { theme: themeName } = usePlatformMeta();

    useHead(
        computed(() => ({
            htmlAttrs: { 'data-area': themeName.value }
        }))
    );
});
